import { useField } from "formik";
import TextField from "@mui/material/TextField";
import DateNodeType from "../../types/DateNodeType";

const DateNode = ({ name, label, required, size, ...props }: DateNodeType) => {
  const [field, meta] = useField(name);

  return (
      <TextField
          {...field}
          size={size || 'small'}
          type="date"
          label={label}
          fullWidth
          required={required}
          InputLabelProps={{ shrink: true }}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          {...props}
      />
  );
};

export default DateNode;